import { Component, Input, OnInit } from '@angular/core';
import { OrderItem } from 'shared';
import { environment } from 'dm-src/environments/environment';
import { AppSettings } from 'shared';
import { OrderItemListService } from '../order-item-list.service';

@Component({
    selector: '[order-missing-item]',
    templateUrl: './order-missing-item.component.html',
    styleUrls: ['./order-missing-item.component.scss'],
})
export class OrderMissingItemComponent {
    @Input() index: number;
    @Input() orderItem: OrderItem;
    @Input() isReturnInProgress = false;
    public productPhotoUrl: string;

    constructor(public orderItemListService: OrderItemListService) {}

    ngOnInit(): void {
        this.productPhotoUrl = `${AppSettings.get('mediaServiceUrl')}/thumbnail/${
            this.orderItem.productPhotoID
        }`;
    }

    public openImage(src: string): void {
        this.orderItemListService.openImage(src);
    }
}
